<template>
    <DxPopup :drag-enabled="dragEnabled"
             :resize-enabled="resizeEnabled"
             :show-title="showTitle"
             :close-on-outside-click="closeOnOutsideClick"
             :show-close-button="showCloseButton"
             :title="title"
             :ref="popupRef"
             :width="width"
             :height="height"
             @showing="onShowing"
             @hiding="onHiding"
             @initialized="onInitialized"
             :visible="visible"
             titleTemplate="title"
             container="#app">
        <template #title>
            <div class="dx-toolbar dx-widget dx-visibility-change-handler dx-collection dx-popup-title dx-has-close-button" role="toolbar">
                <div class="task-toolbar-items-container">
                    <div class="task-toolbar-before" v-html="title"></div>
                    <div class="task-toolbar-after">
                        <div class="dx-button dx-button-normal dx-button-mode-text dx-widget dx-button-has-icon dx-button-bug" aria-label="close" tabindex="0" role="button" @click="onClickBugReport">
                            <div class="dx-button-content">
                                <div :class="['bug-report', bugReportSpinnerActive ? 'spinner' : '']">
                                    <i class="dx-icon iconset bug_report"></i>
                                </div>
                            </div>
                        </div>
                        <div class="dx-button dx-button-normal dx-button-mode-text dx-widget dx-button-has-icon" aria-label="close" tabindex="0" role="button" @click="hidePopup" v-if="showCloseButton">
                            <div class="dx-button-content"><i class="dx-icon dx-icon-close"></i></div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <slot name="content"></slot>
        <slot></slot>
    </DxPopup>
</template>
<script>
    import {
        DxPopup
    } from 'devextreme-vue/popup';

    const customPopupDefaultWidth = '80vw';
    const customPopupDefaultHeight = '80vh';
 
    export default {
        name: 'CustomDxPopup',
        props: {
            title: {
                default: '',
                type: String
            },
            dragEnabled: {
                default: false,
                type: Boolean
            },
            resizeEnabled: {
                default: false,
                type: Boolean
            },
            showTitle: {
                default: true,
                type: Boolean
            },
            closeOnOutsideClick: {
                default: true,
                type: Boolean
            },
            showCloseButton: {
                default: true,
                type: Boolean
            },
            width: {
                default: customPopupDefaultWidth,
                type: [Number, String]
            },
            height: {
                default: customPopupDefaultHeight,
                type: [Number, String]
            },
            onShowing: {
                default: (e) => {},
                type: Function
            },
            onHiding: {
                default: (e) => {},
                type: Function
            },
            onInitialized: {
                default: (e) => {},
                type: Function
            },
            visible: {
                default: false,
                type: Boolean
            },
        },
        components: {
            DxPopup
        },
        data() {
            let randRef = 'cdp-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10);
            return {
                popupRef: randRef,
                bugReportSpinnerActive: false
            }
        },
        methods: {
            hidePopup() {
                this.instance.hide();
            },
            onClickBugReport(e) {
                if (!this.bugReportSpinnerActive) {
                    this.$root.$emit("show_bugreport_popup");
                }
            }
        },
        mounted() {
            this.$root.$on('activate_bug_spinner', () => {
                this.bugReportSpinnerActive = true;
            });
            this.$root.$on('deactivate_bug_spinner', () => {
                this.bugReportSpinnerActive = false;
            });
        },
        created() {
            
        },
        computed: {
            instance() {
                return this.$refs[this.popupRef].instance;
            }
        }
    }
</script>

<style scoped>
    .iconset.bug_report {
        color: #fff;
        font-size: 21px;
    }

    .spinner .iconset.bug_report {
        opacity: 0.3;
    }

    /deep/ .dx-fileuploader-files-container {
        padding-top: 0;
        margin-top: -9px;
    }

    /deep/ .dx-fileuploader-input-wrapper {
        padding-top: 0;
    }

    .task-toolbar-items-container {
        display: flex;
        flex-wrap: nowrap
    }

    .task-toolbar-before {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        position: relative;
        flex-grow: 5;
        height: 36px;
        line-height: 34px;
        font-size: 20px;
        display: block;
    }

    .task-toolbar-after {
        flex-grow: 1;
        position: relative;
        display: block;
        height: 36px;
        text-align: right;
        margin-right: -10px;
        min-width: 96px;
    }

    .task-toolbar-before /deep/ .popup-header-id-and-title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
    }

    .task-toolbar-before /deep/ .popup-header-date {
        width: 126px;
        padding-left: 4px;
        display: block;
    }

    .dx-button-bug {
        margin-right: 16px;
    }

    .spinner {
        background-position: 0px -1px;
        background-size: 20px 20px;
        background-image: url("/img/icons/spinner.gif") !important;
        background-color: rgba(255, 255, 255, 0) !important;
        transition: none !important;
    }

    .spinner a i {
        color: rgba(255, 255, 255, 0.5);
    }
</style>
